import React, { useState, useEffect } from "react";
import { Button, Container } from "react-bootstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faEdit } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { Tooltip } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { userTemplateDetails } from "../../../slice/template";
import { toast } from "react-toastify";

import axios from "axios";
import PopUpModal from "../Modal/PopUpModal";

export default function EditorHeader() {
  const userTemplate = useSelector((state) => state.userTemplate);

  const dispatch = useDispatch();
  const [checkStorage, setCheckStorage] = useState(
    localStorage.getItem("auth_token") ? true : false
  );
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setUserTemplateName(userTemplate.userTemplateName[0].userTemplateName);
    setShow(true);
  };

  const [userTemplateName, setUserTemplateName] = useState(
    userTemplate.userTemplateName[0].userTemplateName
  );
  // const [templateDropdown, setTemplateDropdwon] = useState([]);

  const handleSigRename = (e) => {
    e.preventDefault();

    // call api to rename the current template
    setUserTemplateName(e.target.value);
  };

  const handleSignatureRename = () => {
    dispatch(userTemplateDetails(userTemplateName));
    handleClose();

    toast.dismiss();
    toast.success("Template Title Renamed ", {
      closeOnClick: true,
      theme: "colored",
    });
  };

  // const CreateNewSig = async () => {

  //     const response = await axios.get('/createNewSig');
  //     if (response.data.status === 200) {

  //         dispatch(userTemplateDetails(''))
  //         dispatch(imageUrl(''))
  //         dispatch(resetStyle(true))
  //         dispatch(resetformDetails(true))

  //         toast.dismiss();
  //         toast.success(response.data.message, {
  //             closeOnClick: true,
  //             theme: "colored",
  //         });
  //     }
  // }

  const EditorHeader = () => {
    if (localStorage.getItem("auth_token") !== null) {
      return (
        <Container fluid className="editor-header d-block shadow bg-white">
          <div className="editor-header-wrapper d-flex align-items-center p-2">
            <Link
              to="/my-signatures"
              className="text-decoration-none text-dark "
            >
              <FontAwesomeIcon icon={faAngleLeft} /> Back
            </Link>
            <span className="mx-3">|</span>
            <span className="fw-bold py-1">
              {userTemplate.userTemplateName[0].userTemplateName}
            </span>
            {/* <DropdownButton title={<span className="fw-bold">{state.userTemplateName[0].userTemplateName}</span>}  >
                            {templateDropdown.map((temp) => (
                                <div key={temp.id}>
                                    {temp.user_template_name !== state.userTemplateName[0].userTemplateName ?
                                        <>
                                            <Dropdown.Item>{temp.user_template_name}</Dropdown.Item>
                                            <span className="my-1 border w-100 d-block"></span>
                                        </> : ''}
                                </div>

                            ))}
                            <Dropdown.Item > <FontAwesomeIcon icon={faPlusCircle} className='me-1 text-info' />Add New Signature</Dropdown.Item>
                        </DropdownButton> */}

            {/* <span>
                            <Tooltip title={<span style={{ fontSize: '12px' }}>Create New Signature</span>} placement="top">
                                <FontAwesomeIcon icon={faPlusSquare} className='ms-3 text-info' size='lg' onClick={CreateNewSig} />
                            </Tooltip>
                        </span> */}

            <span>
              <Tooltip
                title={<span style={{ fontSize: "12px" }}>Rename</span>}
                placement="top"
              >
                <FontAwesomeIcon
                  icon={faEdit}
                  className="ms-3 text-info"
                  onClick={handleShow}
                />
              </Tooltip>
            </span>

            {show ? (
              <>
                <PopUpModal
                  title={"Choose Signature Title"}
                  setmodalstate={handleClose}
                  showFooter={false}
                >
                  <div className="d-flex align-items-center flex-column">
                    <input
                      type="text"
                      name="userTemplateName"
                      value={userTemplateName}
                      className="p-1 w-100"
                      onChange={handleSigRename}
                    />
                    <Button
                      className="text-light w-100 mt-4"
                      onClick={handleSignatureRename}
                    >
                      Rename Signature
                    </Button>
                    <Button
                      className="w-100 btn btn-outline-secondary mt-2"
                      onClick={handleClose}
                    >
                      Close
                    </Button>
                  </div>
                </PopUpModal>
              </>
            ) : null}
            <div className="editor-header justify-content-center"></div>
            <div className="editor-header justify-content-end"></div>
          </div>
        </Container>
      );
    } else {
      return "";
    }
  };

  useEffect(() => {
    function handleStorage() {
      setCheckStorage(localStorage.getItem("auth_token") ? true : false);
    }
    window.addEventListener("storage", handleStorage);

    return () => {
      window.removeEventListener("storage", handleStorage);
    };
  }, []);

  // useEffect(() => {
  //   const userTempName = async () => {
  //     try {
  //       setLoading(true);

  //       const response = await axios.get("/getalltemps");
  //       if (response.data.status === 200) {
  //         // setTemplateDropdwon(response.data.temps);
  //       } else {
  //         console.log(response.data);
  //       }
  //       setLoading(false);
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   };

  //   userTempName();
  // }, []);

  useEffect(() => {}, [checkStorage, userTemplateName]);

  return <>{EditorHeader()}</>;
}
